import React from "react";
import Typography from "@material-ui/core/Typography";

function Title({ label }) {
  return <Typography variant="h5" style={{fontWeight:"600"}}>{label}</Typography>;
}

export default Title;
